import {
	SET_AI_BASE,
	MULTIBASE_AI_LIST,
	SET_AI_BASE_REQUEST,
	SET_AI_BASE_REQUEST_SUCCESS,
	SET_AI_BASE_REQUEST_FAILED,
	SET_AI_BASE_REQUEST_FAILED_CLEAR,
	CLEAR_MULTIBASE,
} from "../types"

let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
let selectedProject = localStorage.getItem("selectedProject")

const initialState = {
	selectedBase: selectedProject ? JSON.parse(selectedProject) : {},
	multiBaseList: user?.token?.available_projects ? user.token.available_projects : [],
	isLoading: false,
	token: undefined,
}

// eslint-disable-next-line no-undef
const multiBaseReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_AI_BASE:
			return {
				...state,
				selectedBase: action.payload,
			}
		case MULTIBASE_AI_LIST:
			return {
				...state,
				multiBaseList: action.payload,
			}
		case SET_AI_BASE_REQUEST:
			return {
				...state,
				isLoading: true,
				token: undefined,
			}
		case SET_AI_BASE_REQUEST_SUCCESS:
			return {
				...state,
				isLoading: false,
				token: action.payload,
			}
		case SET_AI_BASE_REQUEST_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
			}
		case SET_AI_BASE_REQUEST_FAILED_CLEAR:
			return {
				...state,
				error: undefined,
			}
		case CLEAR_MULTIBASE:
			return {
				...state,
				selectedBase: {},
				multiBaseList: [],
			}
		default:
			return state
	}
}

export default multiBaseReducer
